import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateIncaComponent } from './template-inca/template-inca.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [TemplateIncaComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
  ],
  exports: [TemplateIncaComponent]
})
export class LayoutModule { }
